import {useEffect, useRef, useState} from "react";
import {string} from "prop-types";

const Image = ({src, alt,...props}: any) => {
  const ref = useRef<HTMLImageElement>(null);


  useEffect(() => {

    if (src instanceof File) {
      const reader = new FileReader();
      reader.onload = function (e) {
        // @ts-ignore
        ref.current?.setAttribute('src', reader.result)
      }
      // @ts-ignore
      reader.readAsDataURL(src);
      return;
    }

    ref.current?.setAttribute('src', src)
  }, [src]);
  if (!(src instanceof File)){
    return <img ref={ref} {...props} src={src} alt={alt}/>
  }
  return <img ref={ref} {...props}  alt={alt}/>
}
export default Image;
